import React, { Component } from "react";
import {
  BASIC_SEARCH_MESSAGE,
  BASIC_SEARCH_TYPE,
  ID_TYPE_NEW,
  LS_BASIC_SEARCH_KEY
} from "../../../../../shared/Constants";
import Input from "../../../../../UI/Input/Input";
import Button from "../../../../../UI/Button/Button";
import classes from "./QuickSearchModal.css";
import { connect } from "react-redux";
import Message from "../../../../../components/Message/Message";
import * as actions from "../../../../../store/actions/index";
import ResultTable from "../../../../../UI/DataTable/DataTable";
import SearchPaginationBtns from "../../SearchPaginationBtns";
import Spinner from '../../../../../UI/Spinner/Spinner';
import CloseStatic from "../../../../../assets/images/CloseStatic.png";

class QuickSearchModal extends Component {
  state = {
    searchForm: {
      quickSearchKeyword: {
        elementType: "input",
        elementConfig: {
          type: "text",
          id: "quickSearchKeyword",
          placeholder: "search",
          maxLength: 101,
        },
        value: "",
        validation: {
          required: false,
          minlength: 2,
          maxlength: 100,
          nospace: true,
          specialchar: [
            "<",
            '"',
            ":",
            ";",
            "=",
            "\\",
            "*",
            "&",
            "(",
            ")",
            "#",
            ",",
          ],
        },
        valid: false,
        touched: false,
        label: null,
        quickSearchInput: true,
        inputType: "QuickSearch",
      },
    },
    formHeader: "Impacted Member Search",
    msg: BASIC_SEARCH_MESSAGE,
    formIsValid: false,
    searchResultPageNumber: 1,
    errorMessage: null
  };

  componentDidMount() {
    this.props.resetSearchResults();
    const data = {
      linkLabel: this.state.linkLabel,
      formHeader: this.state.formHeader,
      formMessage: this.state.msg,
    };

    this.formHeaderHandler(data);
  }

  setSearchString = () => {
    if (this.props.searchedKey) {
      this.setState({
        searchForm: {
          ...this.state.searchForm,
          quickSearchKeyword: {
            ...this.state.searchForm.quickSearchKeyword,
            value: this.props.searchedKey,
          },
        },
      });
    }
  };

  isSelectedMemberValid = (data) => {
    let dupMember = this.props.incidentMembersList.filter(impactedMember => impactedMember.essoData?.uuid === data?.uuid);
    let displayErrorMsg = false;
    let errorMsg = {};
    // if(data?.uuid === this.props.memberData?.healthSafeId){
    //   displayErrorMsg = true;
    //   errorMsg = {message: "Primary Member can't be selected as Impacted Member"};
    // }
     if(dupMember.length > 0){
      displayErrorMsg = true;
      errorMsg = {message: "Same Impacted Member can't be selected again"};
    }
    // else if(data?.idType !== 'HSID-Member' && data?.idType !== 'HSID-Personal Representative'){
    //   displayErrorMsg = true;
    //   errorMsg = {message: "Only HSID Members can be disabled"};
    // }
    // else if(data?.passwordStatus === 'ADMINISTRATIVE_LOCK'){
    //   displayErrorMsg = true;
    //   errorMsg = {message: "Already Disabled members cannot be added"}
    // }
    if(displayErrorMsg){
      this.setState({ ...this.state, errorMessage : <div className={classes.RowMessage}><Message msgType="Error" info={errorMsg} /></div>});
      return false;
    }
    return true;
  }

  errorHandler = (errObj) => {
    this.props.setError(errObj);
  }

  memberSelectionHandler = (data) => {
    if(this.isSelectedMemberValid(data))
    {
      this.props.setImpactedMember(data);
      this.props.closeModal();
      this.props.setAddClicked(true);
    }
  }

  isNextDisabled = (currentPageDataCount) => {
    return (
      this.props.searchResult.length -
        ((this.state.searchResultPageNumber - 1) *
          25 +
          currentPageDataCount) ===
      0
    );
  };

  inputChangedHandler = (event, inputIdentifier) => {

    let updatedForm = { ...this.state.searchForm };

    const updatedFormElement = { ...updatedForm[inputIdentifier] };
    updatedFormElement.value = event.target.value;

    if (event.target.value) {
      updatedFormElement.valid = this.checkValidity(
        updatedFormElement.value,
        updatedFormElement.validation
      );
    } else {
      updatedFormElement.valid = true;
      this.errorHandler(null);
    }
    updatedFormElement.touched = true;
    updatedForm[inputIdentifier] = updatedFormElement;

    let formIsValid = true;
    for (let inputIdentifier in updatedForm) {
      formIsValid =
        event.target.value && updatedForm[inputIdentifier].valid && formIsValid;
    }

    this.setState({ ...this.state,
      searchForm: updatedForm, formIsValid: formIsValid });
  };

  checkValidity(value, rules) {
    let isValid = true;
    let message = null;

    if (rules.required) {
      isValid = value.trim() !== "" && isValid;
    }

    if (rules.minlength) {
      isValid = value.length >= rules.minlength && isValid;
      message =
        !isValid & (message === null)
          ? "Min " + rules.minlength + " characters required"
          : message;
    }

    if (rules.maxlength) {
      isValid = value.length <= rules.maxlength && isValid;
      message =
        !isValid & (message === null)
          ? "Max " + rules.maxlength + " characters allowed"
          : message;
    }

    if (rules.nospace) {
      isValid = value.indexOf(" ") < 0 && isValid;
      message = !isValid & (message === null) ? "No spaces allowed" : message;
    }

    if (rules.specialchar) {
      rules.specialchar.map((char) => {
        return (isValid = value.indexOf(char) < 0 && isValid);
      });
      message =
        !isValid & (message === null)
          ? "Contains invalid special characters"
          : message;
    }
    this.errorHandler({message: message});

    return isValid;
  }

  formHeaderHandler = (data) => {
    this.setState({
        linkLabel: data.linkLabel,
        formHeader: data.formHeader,
        formMessage: data.formMessage
    });
  }

  quickSearchHandler = (event) => {
    event.preventDefault();
    this.props.resetSearchResults();
    this.setState({errorMessage : null });
    this.setPageNumber(1);
    let formData = {
      searchType: BASIC_SEARCH_TYPE,
    };
    for (let formElementIdentifier in this.state.searchForm) {
      formData[formElementIdentifier] =
        this.state.searchForm[formElementIdentifier].value;
    }

    this.props.doSearch(
      {
        searchType: BASIC_SEARCH_TYPE,
        quickSearchKeyword: this.state.searchForm.quickSearchKeyword.value,
      },
      this.props.userType
    );
  };

  getPaginatedData = (data) => {
    const startIndex = this.state.searchResultPageNumber * 25 - 25;
    const endIndex = startIndex + 25;
    const result = data.slice(startIndex, endIndex);
    return result;
  };

  closeSearch = (event) => {
    /*
            This function makes sure to clear the local storage for advance search
            and clear the input values in the current state
        */
    event.preventDefault();
    localStorage.removeItem(LS_BASIC_SEARCH_KEY);
    this.props.setAddClicked(false);
    let searchForm = { ...this.state.searchForm };
    if (
      searchForm["quickSearchKeyword"] &&
      searchForm["quickSearchKeyword"].value
    ) {
      searchForm["quickSearchKeyword"].value = "";
      searchForm["quickSearchKeyword"].touched = false;
    }

    this.setState({ searchForm });
    this.props.resetSearchResults();
    this.props.closeModal();
    this.props.resetSearchIndicators();
  };

  clearSearch = (event) => {
    event.preventDefault();
    localStorage.removeItem(LS_BASIC_SEARCH_KEY);
    this.props.setAddClicked(false);
    let searchForm = { ...this.state.searchForm };
    if (
      searchForm["quickSearchKeyword"] &&
      searchForm["quickSearchKeyword"].value
    ) {
      searchForm["quickSearchKeyword"].value = "";
      searchForm["quickSearchKeyword"].touched = false;
    }

    this.setState({ searchForm, errorMessage: null  });
    this.props.resetSearchResults();
    this.props.resetSearchIndicators();
  }

  setPageNumber = (pageNo) => {
    this.setState({
      searchResultPageNumber: pageNo,
    });
  };

  render() {
    const formsElementsArray = [];

    for (let key in this.state.searchForm) {
      formsElementsArray.push({
        id: key,
        config: this.state.searchForm[key],
      });
    }

    let searchForm = (
      <>
        <div>
          {formsElementsArray.map((formElement) => (
            <Input
              key={formElement.id}
              elementType={formElement.config.elementType}
              elementConfig={formElement.config.elementConfig}
              value={formElement.config.value}
              invalid={!formElement.config.valid}
              shouldValidate={formElement.config.validation}
              touched={formElement.config.touched}
              label={formElement.config.label}
              changed={(event) =>
                this.inputChangedHandler(event, formElement.id)
              }
              inputType={formElement.config.inputType}
            />
          ))}
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            id="cancelSearch"
            btnType="Cancel"
            clicked={this.clearSearch}
            attr={{ type: "button" }}
          >
            Clear
          </Button>
          <Button
            id="quickSearch"
            btnType="Search"
            disabled={!this.state.formIsValid}
            clicked={this.quickSearchHandler}
          >
            Search
          </Button>
        </div>
      </>
    );

    // Search Results
    const resultColumnMapping = [
      { dataField: "firstName", text: "First Name", title: true },
      { dataField: "lastName", text: "Last Name", title: true },
      { dataField: "userName", text: "Username", title: true },
      { dataField: "phone", text: "Phone", title: true },
      { dataField: "email", text: "Email", title: true },
      {
        dataField: "idType",
        text: "ID Type",
        headerAlign: "center",
        align: "center",
      },
    ];

    let searchResult = null;

    if (this.props.searchResult && this.props.searchResult.length > 0) {
      let data = [];
      this.props.searchResult.forEach((item) => {
        const itm = { ...item };
        itm.idType = ID_TYPE_NEW[itm.idType];
        data.push(itm);
      });

      let paginatedData = this.getPaginatedData(data);
      let searchPaginationBtns = (
        <SearchPaginationBtns
          nextClick={this.setPageNumber}
          nextDisabled={() => this.isNextDisabled(paginatedData.length)}
          pageNumber={this.state.searchResultPageNumber}
        />
      );

      searchResult = (
        <ResultTable
          title="Member Search Results"
          data={paginatedData}
          columns={resultColumnMapping}
          clicked={this.memberSelectionHandler}
          paginationComponent={searchPaginationBtns}
        />
      );
    }

    let displayMessage = this.props.displayMessage ? (
      <Message
        msgType={this.props.displayMessage.type}
        info={this.props.displayMessage.info}
      />
    ) : null;

    return (
      <div className={classes.QuickSearch}>
        <img src={CloseStatic} alt={"X"} onClick={this.closeSearch} style={{position:'absolute', top:'5px', right:'5px', height:'40px', width:'40px'}}/>
        <h2 className={classes.FormTitle}>{this.state.formHeader}</h2>
        <p className={classes.Message}>{this.state.formMessage}</p>
        <Message msgType="Error" info={this.props.error} />
        {displayMessage}
        {searchForm}
        {this.state.errorMessage}
        {searchResult}
        {this.props.loading?<Spinner/>:null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    searchResult: state.search.searchResults,
    loading: state.search.loading,
    error: state.search.error,
    displayMessage: state.search.displayMessage,
    userType: state.usr.user.userType,
    memberData: state.member.member,
    impactedMemberData: state.member.impactedMemberData,
    incidentMembersList: state.member.incidentMembersList
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    doSearch: (searchCriteria, userType, source) =>
      dispatch(actions.doSearch(searchCriteria, userType, "ImpactedForm")),
    resetSearchResults: () => dispatch(actions.resetSearchResults()),
    setError: (error) => dispatch(actions.setError(error)),
    setImpactedMember: (data) => dispatch(actions.setImpactedMember(data)),
    resetSearchIndicators: () => dispatch(actions.resetSearchIndicators())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuickSearchModal);
